import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Spin, message } from "antd";
import axios from "axios";
import ProductCard from "../../Components/ProductCard";
import SummaryApi from "../../common/index";

const CategoryProducts = () => {
  const { id } = useParams();  // Get category ID from URL
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryName, setCategoryName] = useState("");

 useEffect(() => {
  const fetchCategoryProducts = async () => {
    try {
      const res = await axios.get(SummaryApi.getProductByCategory(id).url);

      if (res.data.success) {
        // Make sure products exist
        const fetchedProducts = res.data.products || [];
        setProducts(fetchedProducts);

        // Category name: if backend sends it, else fallback
        const catName = res.data.categoryName || (res.data.categories?.[0]?.name) || id;
        setCategoryName(catName);

      } else {
        message.error("No products found for this category");
        setProducts([]);
      }
    } catch (err) {
      console.error("Error fetching category products:", err);
      message.error("Server error while fetching category products");
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  fetchCategoryProducts();
}, [id]);


  if (loading) return <Spin size="large" style={{ display: "block", margin: "50px auto" }} />;

  return (
    <div style={{ padding: "20px" }}>
      <h2>Category: {categoryName || id}</h2>
      <Row gutter={[16, 16]}>
        {products.length ? (
          products.map((product) => (
            <Col key={product.id} xs={24} sm={12} md={8} lg={6}>
              <ProductCard product={product} />
            </Col>
          ))
        ) : (
          <p>No products available in this category.</p>
        )}
      </Row>
    </div>
  );
};

export default CategoryProducts;
